// /components/Modal/File/useFileManagement.js
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFilesThunk, uploadFileThunk, downloadFileThunk, deleteFileThunk } from '../../../stores/file/FileThunks';
import { useSearchStorage } from '../../Storage/StorageWidget';

export const useFileManagement = () => {
  const dispatch = useDispatch();
  const storageAPI = useSearchStorage();
  const fileState = useSelector((state) => state.file);

  const getFileList = useCallback((params) => {
    if (!params) return;
    return dispatch(getFilesThunk(params));
  }, [dispatch]);

  const fileUpload = useCallback(async (formData) => {
    if (!formData) return;
    await dispatch(uploadFileThunk(formData));
    storageAPI();
  }, [dispatch, storageAPI]);

  const fileDownload = useCallback(async (params) => {
    if (!params) return;
    const action = await dispatch(downloadFileThunk(params));
    if (downloadFileThunk.fulfilled.match(action)) {
      const { data, headers } = action.payload;
      let fileName = 'downloaded_file';

      const disposition = headers?.['content-disposition'];
      if (disposition) {
        let match = disposition.match(/filename\*=UTF-8''([^;]+)/);
        if (match) {
          fileName = decodeURIComponent(match[1]);
        } else {
          match = disposition.match(/filename="([^"]+)"/);
          if (match) fileName = decodeURIComponent(match[1]);
        }
      }

      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } else {
      console.error('다운로드 실패', action.payload || action.error);
    }
  }, [dispatch]);

  const fileDelete = useCallback(async (params) => {
    if (!params) return;
    const action = await dispatch(deleteFileThunk(params));
    if (deleteFileThunk.fulfilled.match(action)) {
      storageAPI();
    } else {
      console.error('삭제 실패', action.payload || action.error);
    }
  }, [dispatch, storageAPI]);

  return {
    getFileList,
    fileUpload,
    fileDownload,
    fileDelete,
    fileState,
  };
};
